import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledNoLogo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: ${({ $size }) => `${$size}px` || '128px'};
    height: ${({ $size }) => `${$size}px` || '128px'};
    border-radius: 50%;
    border: 1px solid ${COLORS.$gray20Black};
    background: ${COLORS.$gray10Black};

    &:hover {
        background: ${COLORS.$gray40Black};
        opacity: 0.8;

        > p {
            display: none;
        }

        .anticon {
            color: ${COLORS.$white};
        }
    }

    + .ant-btn {
        position: absolute;
        right: calc(50% - 100px);
        bottom: -5px;
    }
`;

export const StyledHover = styled.div`
    position: relative;
`;

export const StyledIcon = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    top: 0;
    left: 0;
    z-index: 3;
    border-radius: 50%;

    .anticon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;
